/**
 * Benchmarking graph percentages (template-parts/charts/stacked-bar-line-graph.php).
 *
 * - A hospital's bar is its own Yes rate for the month.
 * - The average line is all hospitals combined (MCH-205): every hospital's
 *   Yes answers over every hospital's answers.
 *
 * Month entries list every hospital, including ones with no submissions that
 * month, so nothing here divides by the number of hospitals listed.
 */
(function (root) {
  "use strict";

  function percent(part, whole) {
    return whole > 0 ? Math.round((part / whole) * 100 * 10) / 10 : 0; // 1 decimal place
  }

  function hospitalPercent(hospital) {
    return percent(hospital.hospital_total_yes || 0, hospital.hospital_total_answers || 0);
  }

  function averagePercent(monthEntry) {
    const hospitals = (monthEntry && monthEntry.hospital) || [];
    let yes = 0;
    let answers = 0;
    hospitals.forEach(function (h) {
      yes += h.hospital_total_yes || 0;
      answers += h.hospital_total_answers || 0;
    });
    return percent(yes, answers);
  }

  root.MchriBenchmarkMaths = root.MchriBenchmarkMaths || {
    hospitalPercent: hospitalPercent,
    averagePercent: averagePercent,
  };
})(typeof window !== "undefined" ? window : globalThis);
